import React from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Subscription } from '../types';

interface TrialBannerProps {
  subscription: Subscription;
}

const TrialBanner: React.FC<TrialBannerProps> = ({ subscription }) => {
  const history = useHistory();
  const { t } = useTranslation('subscription');

  const calculateRemainingDays = (endDate: string): number => {
    const now = new Date();
    const end = new Date(endDate);
    const diffTime = end.getTime() - now.getTime();
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays > 0 ? diffDays : 0;
  };

  const remainingDays = calculateRemainingDays(subscription.currentPeriodEnd);

  return (
    <div
      className='trial-banner'
      style={{
        background:
          'linear-gradient(135deg, rgba(139, 92, 246, 0.15) 0%, rgba(59, 130, 246, 0.15) 100%)',
        border: '1px solid rgba(139, 92, 246, 0.3)',
        borderRadius: '12px',
        margin: '12px 0px 12px 0px',
        width: '100%',
      }}
    >
      <div className='trial-banner__body'>
        <div className='trial-banner__top'>
          <span
            style={{
              background: 'rgba(139, 92, 246, 0.2)',
              color: '#a78bfa',
              padding: '4px 12px',
              borderRadius: '12px',
              fontSize: '12px',
              fontWeight: '600',
              textTransform: 'uppercase',
              letterSpacing: '0.5px',
            }}
          >
            {t('trialBanner.freeTrial')}
          </span>
          <p
            style={{
              margin: 0,
              color: 'var(--text-primary)',
              fontSize: '14px',
              fontWeight: '500',
            }}
          >
            {t('trialBanner.daysRemaining', {
              days: remainingDays,
              dayLabel:
                remainingDays === 1 ? t('dayLabel.one') : t('dayLabel.other'),
            })}
          </p>
        </div>
        <button
          onClick={() => history.push('/subscription')}
          className='btn-primary btn trial-banner__btn'
          style={{
            fontSize: '14px',
            padding: '12px 20px',
          }}
        >
          {t('trialBanner.activateSubscription')}
        </button>
      </div>
    </div>
  );
};

export default TrialBanner;
